<template>
  <div class="my-page">
    <!-- 用户信息头部 -->
    <div class="user-header">
      <div class="avatar" @click="checkLogin">
        <img v-if="userAvatar" :src="userAvatar" alt="头像" />
        <div v-else class="avatar-placeholder">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div class="user-info">
        <h2 class="nickname">{{ userNickname || '点击登录' }}</h2>
        <p class="user-id" v-if="userId">ID: {{ userId }}</p>
      </div>
    </div>

    <!-- 功能菜单 -->
    <div class="menu-section">
      <div class="menu-group">
        <div class="menu-item" @click="goToPage('/my-works')">
          <div class="menu-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 19L19 12L22 15L15 22L12 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18 13L16.5 5.5L2 2L5.5 16.5L13 18L18 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="menu-label">我的作品</span>
          <svg class="arrow-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <div class="menu-item" @click="goToPage('/tools')">
          <div class="menu-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
              <path d="M19.4 15C20.1 14.3 20.5 13.2 20.5 12C20.5 10.8 20.1 9.7 19.4 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M15 19.4C15.7 20.1 16.8 20.5 18 20.5C19.2 20.5 20.3 20.1 21 19.4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M4.6 9C3.9 9.7 3.5 10.8 3.5 12C3.5 13.2 3.9 14.3 4.6 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M9 4.6C8.3 3.9 7.2 3.5 6 3.5C4.8 3.5 3.7 3.9 3 4.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M15 4.6C15.7 3.9 16.8 3.5 18 3.5C19.2 3.5 20.3 3.9 21 4.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M4.6 15C3.9 15.7 3.5 16.8 3.5 18C3.5 19.2 3.9 20.3 4.6 21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M9 19.4C8.3 20.1 7.2 20.5 6 20.5C4.8 20.5 3.7 20.1 3 19.4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          <span class="menu-label">全部工具</span>
          <svg class="arrow-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <!-- 代理中心入口（仅代理可见） -->
        <div v-if="isAgent" class="menu-item" @click="goToAgentCenter">
          <div class="menu-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="menu-label">代理中心</span>
          <svg class="arrow-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <div class="menu-group">
        <div class="menu-item" @click="showAbout = true">
          <div class="menu-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <line x1="12" y1="16" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <line x1="12" y1="8" x2="12.01" y2="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          <span class="menu-label">关于我们</span>
          <svg class="arrow-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <div class="menu-item" @click="checkLoginStatus">
          <div class="menu-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M9 16H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="2"/>
              <path d="M7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          <span class="menu-label">联系客服</span>
          <svg class="arrow-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>

    <!-- 退出登录按钮 -->
    <button class="logout-btn" v-if="userNickname" @click="logout">
      退出登录
    </button>

    <!-- 关于弹窗 -->
    <div class="modal-overlay" v-if="showAbout" @click="showAbout = false">
      <div class="modal-content" @click.stop>
        <h3 class="modal-title">关于 Nano Banana</h3>
        <p class="modal-version">版本 1.0.0</p>
        <p class="modal-desc">
          Nano Banana 是一款基于 AI 技术的图片编辑工具，<br>
          用自然语言轻松编辑图片，让创意无限可能。
        </p>
        <button class="modal-close" @click="showAbout = false">知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetUserAgentByOpenId } from '@/utils/api';

export default {
  name: 'MyPage',
  data() {
    return {
      userNickname: '',
      userAvatar: '',
      userId: '',
      showAbout: false,
      isAgent: false,
      checkingAgent: false
    };
  },
  mounted() {
    this.loadUserInfo();
    this.checkUserAgentStatus();
  },
  methods: {
    loadUserInfo() {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        this.userNickname = user.nickname || '微信用户';
        this.userAvatar = user.avatar || '';
        this.userId = user.openid || '';
      }
    },
    checkLogin() {
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        // 触发微信登录
        const appId = process.env.VUE_APP_WECHAT_APPID;
        const redirectUri = window.location.href;
        const encodedUrl = encodeURIComponent(redirectUri.split('#')[0]);
        const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodedUrl}&response_type=code&scope=snsapi_base&state=wechat_login#wechat_redirect`;
        window.location.href = authUrl;
      }
    },
    checkLoginStatus() {
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        alert('请先登录');
        this.checkLogin();
      } else {
        alert('客服微信：nanobanana001');
      }
    },
    goToVip() {
      this.$router.push('/vip');
    },
    goToPage(path) {
      this.$router.push(path);
    },
    logout() {
      if (confirm('确定要退出登录吗？')) {
        localStorage.removeItem('user');
        localStorage.removeItem('agentId');
        this.userNickname = '';
        this.userAvatar = '';
        this.userId = '';
        this.isAgent = false;
        alert('已退出登录');
      }
    },

    /**
     * 检查用户代理状态
     */
    async checkUserAgentStatus() {
      // 如果没有登录，则不是代理
      if (!this.userId) {
        this.isAgent = false;
        return;
      }

      this.checkingAgent = true;
      try {
        // 从localStorage获取保存的agentId（通过链接访问时保存的）
        const localStorageAgentId = localStorage.getItem('agentId');

        // 如果localStorage中没有agentId，则不是代理
        if (!localStorageAgentId) {
          this.isAgent = false;
          return;
        }

        // 通过API获取用户在数据库中对应的agent信息
        const response = await apiGetUserAgentByOpenId(this.userId);

        if (response.success) {
          // 检查返回的是单个agent还是多个agents
          if (response.agents && Array.isArray(response.agents)) {
            // 处理多个agent的情况
            const matchingAgent = response.agents.find(agent =>
              agent.id.toString() === localStorageAgentId.toString()
            );
            this.isAgent = !!matchingAgent;
          } else if (response.agent) {
            // 处理单个agent的情况（向后兼容）
            this.isAgent = response.agent.id.toString() === localStorageAgentId.toString();
          } else {
            this.isAgent = false;
          }
        } else {
          this.isAgent = false;
        }
      } catch (error) {
        console.error('检查代理状态失败:', error);
        this.isAgent = false;
      } finally {
        this.checkingAgent = false;
      }
    },

    /**
     * 跳转到代理中心
     */
    goToAgentCenter() {
      this.$router.push('/agent-center');
    }
  }
};
</script>

<style scoped>
.my-page {
  min-height: 100vh;
  background: #faf8f5;
  padding: 20px;
  padding-bottom: 80px;
}

.user-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 0;
}

.avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  background: #f0f0f0;
  cursor: pointer;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.avatar-placeholder svg {
  width: 36px;
  height: 36px;
  stroke: white;
}

.user-info {
  flex: 1;
}

.nickname {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.user-id {
  font-size: 12px;
  color: #999;
}

.vip-card {
  background: linear-gradient(135deg, #ffd700 0%, #ffecb3 100%);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
}

.vip-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.vip-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.vip-desc {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.vip-action {
  background: white;
  color: #ff9500;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.arrow-icon {
  width: 16px;
  height: 16px;
  stroke: currentColor;
}

.menu-section {
  margin-top: 20px;
}

.menu-group {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s ease;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:active {
  background: #fafafa;
}

.menu-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}

.menu-icon svg {
  width: 100%;
  height: 100%;
  stroke: #666;
}

.menu-label {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.arrow-right {
  width: 20px;
  height: 20px;
  stroke: #ccc;
}

.logout-btn {
  width: 100%;
  padding: 16px;
  background: white;
  color: #ff4444;
  border: 1px solid #ff4444;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 20px;
  transition: all 0.2s ease;
}

.logout-btn:active {
  background: #ff4444;
  color: white;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 16px;
  padding: 30px 20px;
  max-width: 300px;
  text-align: center;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.modal-version {
  font-size: 14px;
  color: #999;
  margin-bottom: 16px;
}

.modal-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 24px;
}

.modal-close {
  background: linear-gradient(135deg, #ff9500 0%, #ffb347 100%);
  color: white;
  border: none;
  padding: 12px 40px;
  border-radius: 25px;
  font-size: 14px;
  cursor: pointer;
}
</style>